import { Router } from "vue-router";

export const checkToken = (router: Router) => {
    const token = sessionStorage.getItem('token');
    if (!token) {
        router.push('/auth/login');
    }
}

export const onCompletedLogin = (token: string, router: Router) => {
    sessionStorage.setItem('token', token);
    router.push('/management/products');
}

export const onLogout = (router: Router) => {
    sessionStorage.removeItem('token');
    router.replace('/auth/login');
}